import { useParams, Link } from 'react-router-dom';
import Icon from '../components/ui/Icon.jsx';
import { useApi } from '../hooks/useApi.js';
import { getNewsArticle } from '../api/newsApi.js';
import './NewsArticlePage.css';

function NewsArticlePage() {
  const { id } = useParams();
  const { data: article, loading } = useApi(() => getNewsArticle(id), [id]);

  if (loading) return <div className="na-loading">載入中…</div>;
  if (!article) return null;

  return (
    <main className="v3-na">
      <nav className="na-crumbs">
        <Link to="/news">最新資訊</Link> / <b>{article.category}</b>
      </nav>

      <p className="na-cat">{article.category} · {article.category.toUpperCase()}</p>
      <h1 className="na-h1">{article.title}</h1>
      <div className="na-meta">
        <span>{article.date}</span>
        <span>{article.readTime}</span>
        <span>作者 · {article.author}</span>
      </div>

      <div className="na-cover">
        <svg viewBox="0 0 200 600" aria-hidden="true">
          <use href="#dart-full" />
        </svg>
      </div>

      {article.content?.map((block, i) => {
        if (block.type === 'lead')  return <p key={i} className="na-lead">{block.text}</p>;
        if (block.type === 'p')    return <p key={i} className="na-p">{block.text}</p>;
        if (block.type === 'h2')   return <h2 key={i} className="na-h2">{block.text}</h2>;
        if (block.type === 'quote') return <blockquote key={i} className="na-quote">{block.text}</blockquote>;
        return null;
      })}

      <div className="na-author">
        <div className="na-av">道</div>
        <div>
          <b>{article.author}</b>
          <small>編輯 · {article.authorDate}</small>
        </div>
      </div>

      <div className="na-share">
        <button><Icon name="share" size={14} /> 分享連結</button>
        <button>LINE</button>
        <button>X / Twitter</button>
      </div>

      {article.related?.length > 0 && (
        <section className="na-related">
          <h3>延伸閱讀</h3>
          <div className="na-related-list">
            {article.related.map(n => (
              <Link to={`/news/${n.id}`} key={n.id} className="na-related-item">
                <div className={`na-related-thumb${n.theme ? ' ' + n.theme : ''}`} />
                <div>
                  <b>{n.title}</b>
                  <small>{n.category} · {n.date} · {n.readTime}</small>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </main>
  );
}

export default NewsArticlePage;
